import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [jwtToken, setJwtToken] = useState('');
  const [userRoles, setUserRoles] = useState([]);

  // Carica il token e i ruoli dell'utente dal localStorage al caricamento della pagina
  useEffect(() => {
    const storedToken = sessionStorage.getItem('jwtToken');
    const storedRoles = JSON.parse(sessionStorage.getItem('userRoles'));
    if (storedToken) {
      setJwtToken(storedToken);
    }
    if (storedRoles) {
      setUserRoles(storedRoles);
    }
  }, []);

  const login = (token, roles) => {
    setJwtToken(token);
    setUserRoles(roles);
    // Salva il token e i ruoli nel localStorage al login
    sessionStorage.setItem('jwtToken', token);
    sessionStorage.setItem('userRoles', JSON.stringify(roles));
  };

  const logout = () => {
    setJwtToken('');
    setUserRoles([]);
    // Rimuovi il token e i ruoli dal localStorage al logout
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('userRoles');
  };

  return (
    <AuthContext.Provider value={{ jwtToken, userRoles, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve essere utilizzato all\'interno di un AuthProvider');
  }
  return context;
};
